import { encodeEnvelope, MAX_PAYLOAD_BYTES } from './protocol/envelope.js';

export function describeMessage(text, {
  mode = 'static', profile = 'screen-mono', chunkSize = 16, holdMs = 900, repeats = 2,
} = {}) {
  const message = text.trim();
  const bytes = new TextEncoder().encode(message).length;
  const valid = bytes <= MAX_PAYLOAD_BYTES;
  const counter = `${bytes}/${MAX_PAYLOAD_BYTES} octets`;
  if (!valid) return { bytes, valid, label: `${counter} · trop long (accents et emoji comptent davantage)` };
  if (!bytes) return { bytes, valid, label: `${counter} · texte, lien ou code court` };
  if (profile === 'flashlight') return { bytes, valid, label: `${counter} · torche lente, durée après mesure` };
  if (mode === 'static') return { bytes, valid, label: `${counter} · 1 QR fixe, affiché jusqu’à fermeture` };
  const encoded = encodeEnvelope({ source: 1, payload: message });
  const packets = Math.ceil(encoded.text.length / chunkSize);
  const minimumSeconds = packets * holdMs * (mode === 'udp' ? repeats : 1) / 1000;
  return {
    bytes, valid, packets, minimumSeconds,
    label: `${counter} · ${packets} paquets · ≥ ${minimumSeconds.toLocaleString('fr-FR', { maximumFractionDigits: 1 })} s${mode === 'arq' ? ' + confirmation/reprises' : ' · non confirmé'}`,
  };
}
